import React from "react";
import { Field, FieldMetaProps, FieldProps, FormikProps } from "formik";
import { FormValues } from "../types";
import { Box, IconButton, TextField } from "@origin-digital/ods-core";
import { CalculatorIcon } from "src/components/Projects/Icons";

interface IGasLoadFieldProps {
  name: string;
  label: string;
  openDialog: () => void;
}

const ResidentialGasLoadField = (props: IGasLoadFieldProps) => {
  const { name, label, openDialog } = props;
  return (
    <Field name={name}>
      {({
        field,
        meta,
      }: {
        field: FormikProps<FieldProps>;
        meta: FieldMetaProps<FormValues>;
      }) => (
        <TextField
          {...field}
          //dummy to not allow change
          onChange={() => {}}
          id="gas-load-field"
          label={label}
          variant="outlined"
          error={!!meta.error}
          endIcon={
            <Box display="flex">
              <IconButton
                aria-label="Gas appliance load calculator"
                noIconPadding
                onClick={openDialog}
              >
                <CalculatorIcon />
              </IconButton>
              {/* If error or validated, show icon here */}
            </Box>
          }
        />
      )}
    </Field>
  );
};

export default ResidentialGasLoadField;
